// extracted by mini-css-extract-plugin
module.exports = {"commentWrap":"followers_commentWrap__3NJ3s","commentHeader":"followers_commentHeader__1q2Bc","userWrap":"followers_userWrap__1000q"};